import { useTranslation } from "next-i18next";
import Input from "ab-input";
import Text from "ab-text";
import "./ab-personalizacion.scss";

const Personalizacion = ({
  configuradorEstuches,
  i18n,
  customiceLabelPrice,
  isEven,
  // etiqueta
  personalizeEtiqueta,
  setPersonalizeEtiqueta,
  etiquetaText,
  setEtiquetaText,
  // tarjeton
  personalizeMessage,
  setPersonalizeMessage,
  tarjetaText,
  setTarjetaText,

  isEstuche,

  serviceSKU,
  etiquetaSKU,
}) => {
  // return null;
  const { t } = useTranslation("common", { i18n });
  const nuevaEtiqueta =
  "https://abadia.glbcrt.com/wp-content/uploads/personalizacion.png"
    const imagenEtiqueta = isEstuche
    ? configuradorEstuches?.imagenTirilla?.mediaItemUrl || nuevaEtiqueta
    : nuevaEtiqueta;

  console.log("configuradorEstuches", configuradorEstuches);
  return (
    <div
      className={`personalizacion ${isEven ? "even" : "odd"}${
        !isEstuche ? " our-wine" : ""
      }`}
    >
      {isEstuche ? <Text element="h3">{t("toque")}</Text> : null}

      <Input
        type="checkbox"
        label={`${t("customize")} ${customiceLabelPrice}`}
        value={personalizeEtiqueta}
        onChange={(val) => setPersonalizeEtiqueta(val)}
      />
      {personalizeEtiqueta ? (
        <>
          <Text style={{ marginLeft: 45, marginTop: -10 }}>
            {`- ${serviceSKU?.name}: (+${serviceSKU?.price})`}
          </Text>
          <Text
            element="p"
            style={{ marginLeft: 45, marginTop: 0, marginBottom: 25 }}
          >
            {`- ${t("personalizacion")}`}
          </Text>
        </>
      ) : null}

      {personalizeEtiqueta ? (
        <Input
          placeholder={t("labelText")}
          value={etiquetaText}
          onChange={(val) => setEtiquetaText(val?.substring(0, 25))}
        />
      ) : null}

      {personalizeEtiqueta && imagenEtiqueta ? (
        <>
          <picture>
            <source
              srcSet={configuradorEstuches?.imagenTirilla}
              media="(max-width: 450px)"
            />
            <img
              src={imagenEtiqueta}
              loading="lazy"
              width={350}
              className={"zoom-image"}
            />
          </picture>
          <Text element="p" style={{ marginLeft: 75, marginTop: 5 }}>
            {t("personalizacion-ejemplo")}
          </Text>
        </>
      ) : null}
      {isEstuche ? (
        <>
          <Input
            type="checkbox"
            label={t("addNote")}
            value={personalizeMessage}
            onChange={(val) => setPersonalizeMessage(val)}
          />

          {personalizeMessage ? (
            <textarea
              placeholder={t("note")}
              value={tarjetaText}
              onChange={(e) =>
                setTarjetaText(e.target.value?.substring(0, 200))
              }
            />
          ) : null}

          {personalizeMessage &&
          configuradorEstuches?.imagenTarjeton?.mediaItemUrl ? (
            <picture>
              <source
                srcSet={configuradorEstuches?.imagenTarjeton}
                media="(max-width: 350px)"
              />
              <img
                src={configuradorEstuches?.imagenTarjeton?.mediaItemUrl}
                loading="lazy"
                width={350}
              />
            </picture>
          ) : null}
        </>
      ) : null}

      {personalizeEtiqueta || personalizeMessage ? (
        <Text element="span" className="deliveryNote">
          {t("deliveryTime")}
        </Text>
      ) : null}
    </div>
  );
};

export default Personalizacion;
